import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface FloatTrendChartProps {
  xAxisData: string[];
  avgFloat: number[];
  minFloat: number[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function FloatTrendChart({
  xAxisData,
  avgFloat,
  minFloat,
  height = 260,
  showDataLabels = true,
  density = 'overview',
}: FloatTrendChartProps) {
  const series = useMemo(
    () => [
      { name: 'Avg float (days)', data: avgFloat },
      { name: 'Min float (days)', data: minFloat },
    ],
    [avgFloat, minFloat]
  );
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
